import { NavLink } from 'react-router-dom';
import AccountMenu from './menu';
import CreateUpdatePostModal from '../../modals/post/CreateUpdatePost';
import useCreateUpdatePost from '../../hooks/post/useCreateUpdatePost.js';
import { getToken } from '../../storage/LocalStorageService';
import { useTranslation } from 'react-i18next';
import { LuLogIn } from "react-icons/lu"; // LuInfo, LuHeart, LuBanknote

const Navbar = () => {
  const { isOpen, close } = useCreateUpdatePost();
  const { access_token } = getToken();
  const { t } = useTranslation('common')
  const translation = t('menu')
  
  // const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  
  // const nav_message = t('nav-message')

  // const messages = [
  //   {
  //     text: `${nav_message.first}`,
  //     icon: <LuInfo className="text-emerald-500" />,
  //     bgColor: "bg-emerald-50 dark:bg-emerald-900/20",
  //     textColor: "text-emerald-800 dark:text-emerald-200",
  //     borderColor: "border-emerald-200 dark:border-emerald-700"
  //   },
  //   {
  //     text: `${nav_message.second}`,
  //     icon: <LuHeart className="text-rose-500" />,
  //     bgColor: "bg-rose-50 dark:bg-rose-900/20",
  //     textColor: "text-rose-800 dark:text-rose-200",
  //     borderColor: "border-rose-200 dark:border-rose-700"
  //   },
  //   {
  //     text: `${nav_message.third}`,
  //     icon: <LuBanknote className="text-blue-500" />,
  //     bgColor: "bg-blue-50 dark:bg-blue-900/20",
  //     textColor: "text-blue-800 dark:text-blue-200",
  //     borderColor: "border-blue-200 dark:border-blue-700"
  //   },
  //   {
  //     text: `${nav_message.fourth}`,
  //     icon: <LuInfo className="text-orange-500" />,
  //     bgColor: "bg-orange-50 dark:bg-orange-900/20",
  //     textColor: "text-orange-800 dark:text-orange-200",
  //     borderColor: "border-orange-200 dark:border-orange-700"
  //   },
  //   {
  //     text: `${nav_message.fifth}`,
  //     icon: <LuInfo className="text-violet-500" />,
  //     bgColor: "bg-violet-50 dark:bg-violet-900/20",
  //     textColor: "text-violet-800 dark:text-violet-200",
  //     borderColor: "border-violet-200 dark:border-violet-700"
  //   },
  //   {
  //     text: `${nav_message.sixth}`,
  //     icon: <LuInfo className="text-violet-500" />,
  //     bgColor: "bg-violet-50 dark:bg-violet-900/20",
  //     textColor: "text-violet-800 dark:text-violet-200",
  //     borderColor: "border-violet-200 dark:border-violet-700"
  //   }
  // ];

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCurrentMessageIndex((prevIndex) => 
  //       (prevIndex + 1) % messages.length
  //     );
  //   }, 4000);

  //   return () => clearInterval(interval);
  // }, [messages.length]);

  return (
    <>
      <nav className="bg-white top-0 flex items-center justify-between w-full fixed z-50 dark:bg-gray-700 border-b border-gray-200 dark:border-gray-700 px-2 sm:px-4">
        <div className="flex items-center">
          <NavLink to="/" className="text-xl sm:text-2xl text-dark font-bold dark:text-white hover:text-gray-600 transition-colors">
            AddaZakat
          </NavLink>
        </div>

        {/* Center: Professional Message Display */}
        {/* <div className="relative flex-1 max-w-sm sm:max-w-md md:max-w-lg mx-2 sm:mx-4 h-10 flex items-center justify-center overflow-hidden py-1">
          
          <div className="relative w-full h-full">
            {messages.map((message, index) => (
              <div
                key={index}
                className={`
                  absolute inset-0 flex items-center gap-2 sm:gap-3 px-2 sm:px-4 py-2 rounded-full border
                  transition-opacity duration-500 ease-in-out
                  ${message.bgColor} ${message.textColor} ${message.borderColor}
                  shadow-sm hover:shadow-md w-full
                  ${index === currentMessageIndex ? 'opacity-100' : 'opacity-0'}
                `}
              >
                <div className="flex-shrink-0 hidden sm:block">
                  {message.icon}
                </div>
                <span className="text-xs sm:text-sm font-medium text-center leading-tight">
                  {message.text}
                </span>
              </div>
            ))}
          </div>
        
        </div> */}

        <ul className="flex space-x-2 sm:space-x-4 items-center">
          <li>
            {access_token ? (
              <AccountMenu />
            ) : (
              <NavLink
                to="/auth/login"
                className="flex items-center gap-1 sm:gap-2 px-1 sm:px-4 py-1 rounded-xl border shadow-sm bg-blue-600 hover:bg-blue-700 text-white border-blue-600 transition-all duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 font-medium hover:shadow-md transform hover:scale-105 my-2"
              >
                <span className="text-sm sm:text-base">{translation.login}</span>
                <LuLogIn className="text-base sm:text-lg" />
              </NavLink>
            )}
          </li>
        </ul>
      </nav>
      {isOpen && <CreateUpdatePostModal onClose={close} />}
    </>
  );
};

export default Navbar;